export default __webpack_public_path__ + "06781587bf8b45d49e9f40a89adee4d7.png";